/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGameUserRewardPrompt.vue?vue&type=template&id=22fb3034&scoped=true"
import script from "./popGameUserRewardPrompt.vue?vue&type=script&lang=js"
export * from "./popGameUserRewardPrompt.vue?vue&type=script&lang=js"
import style0 from "./popGameUserRewardPrompt.vue?vue&type=style&index=0&id=22fb3034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb3034",
  null
  
)

export default component.exports